import axios from "axios";

import { baseUrl } from "services/client";

export async function fetchCurrentMonthActionSummary() {
  /** Aggregated token numbers for the current month. */
  const { data } = await axios.get(`${baseUrl}tokens/current_month/`);
  return data;
}
